import { render, staticRenderFns } from "./webThird.vue?vue&type=template&id=82c7a05c&scoped=true"
import script from "./webThird.vue?vue&type=script&lang=js"
export * from "./webThird.vue?vue&type=script&lang=js"
import style0 from "./webThird.vue?vue&type=style&index=0&id=82c7a05c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c7a05c",
  null
  
)

export default component.exports